module.exports = __webpack_public_path__ + "assets/undo-mobile.58f7c1fd.svg";